export { default } from './TiraVideos';
